import * as React from "react";
import { IconProps } from "./";

export const DeleteTacIcon = (props: IconProps) => {
    const style = props.onClick ? {cursor: 'pointer'} : null

    return (
        <svg style={style} onClick={props.onClick} version="1.1" id="delete-tac"  x="0px" y="0px" width="30px" height="30px" viewBox="-10 10.854 30 30">
            <g>
                <path fill="#959595" d="M7.104,10.997c0-0.509-0.391-0.924-0.869-0.924H3.764c-0.478,0-0.868,0.415-0.868,0.924v0.924h4.208V10.997 z"/>
                <path fill="#959595" d="M-4.218,37.297c0,1.446,1.112,2.63,2.471,2.63h13.495c1.358,0,2.47-1.184,2.47-2.63V16.883H-4.218V37.297z M9.342,21.008c0-0.547,0.422-0.997,0.936-0.997s0.935,0.449,0.935,0.997v14.866c0,0.547-0.421,0.995-0.935,0.995 s-0.936-0.448-0.936-0.995V21.008z M4.065,21.008c0-0.547,0.42-0.997,0.935-0.997c0.514,0,0.935,0.449,0.935,0.997v14.866 c0,0.547-0.421,0.995-0.935,0.995c-0.515,0-0.935-0.448-0.935-0.995V21.008z M-1.213,21.008c0-0.547,0.421-0.997,0.936-0.997 c0.514,0,0.935,0.449,0.935,0.997v14.866c0,0.547-0.421,0.995-0.935,0.995c-0.515,0-0.936-0.448-0.936-0.995V21.008z"/>
                <path fill="#959595" d="M13.851,12.544H-3.852c-0.917,0-1.669,0.8-1.669,1.777v1.352c0,0.234,0.181,0.426,0.401,0.426h20.24 c0.22,0,0.401-0.192,0.401-0.426v-1.352C15.521,13.345,14.769,12.544,13.851,12.544z"/>
            </g>
        </svg>
    );
};
